<template>
  <PageErreurMinerve :erreur="ERREURS[403]">
    <template #texte>
      <p>
        Cette page est réservée aux utilisateurs abonnés à une veille privée.
        <template v-if="userSettingsStore.hasPermission('BASIC')">
          Choisissez une autre veille dans le menu.
        </template>
        <template v-else>
          Les veilles personnalisées sont des fonctionnalités des abonnements
          payants : comparez nos abonnements.
        </template>
        Une erreur ?
        <a @click="askAboutForbiddenDashboard">Contactez-nous</a>.
      </p>
    </template>
    <template #actions>
      <button class="btn-primary" @click="refreshWithSavedDashboard">
        {{ ERREURS[403].cta }}
      </button>
      <BaseLink
        v-if="!userSettingsStore.hasPermission('BASIC')"
        href="https://www.follaw.sv/#pricing-table"
        class="btn-primary"
      >
        {{ ERREURS[403].cta2 }}
      </BaseLink>
    </template>
  </PageErreurMinerve>
</template>

<script setup>
import { useRouter, useRoute } from "vue-router";
import BaseLink from "@follaw-fr/components/general/atoms/BaseLink.vue";
import PageErreurMinerve from "@follaw-fr/components/reusable/minerve/PageErreurMinerve.vue";
import { ERREURS } from "@follaw-fr/components/reusable/minerve/erreursMinerve";
import { useUserSettingsStore } from "@follaw-fr/stores/user-settings";
import { useUserStore } from "@follaw-fr/stores/user";

const userSettingsStore = useUserSettingsStore();
const userStore = useUserStore();

const router = useRouter();
const route = useRoute();

const refreshWithSavedDashboard = () => {
  router.push({
    path: route.query.accessTo,
    query: {
      dashboard: userStore.selectedDashboardId,
    },
  });
};

const askAboutForbiddenDashboard = () => {
  // Use the Crisp API to automatically start a conversation with the Sales team
  window.$crisp.push(["do", "chat:open"]);

  window.$crisp.push([
    "set",
    "message:text",
    [
      `Bonjour, j'ai accédé à un lien vers la veille ${route.query.withDashboard} mais il semble que mon compte n'y ait pas accès. Pouvez-vous m'aider à comprendre la situation ?`,
    ],
  ]);
};
</script>

<style scoped lang="scss">
a {
  cursor: pointer;
}

.btn-primary:hover {
  color: #fff;
}
</style>
